/* eslint-disable import/prefer-default-export */
import moment from 'moment-timezone';
import { END_OPTION_SPECIFIC_DATE } from '../../../edit-listing/common/config/sessions';

export const getNumberOfNonCustomSessions = (publicData) => {
  const {
    isRecurring,
    numberOfSessions,
    recurringOption,
    endDate,
    firstSession,
    endOption,
    timezone = 'Europe/London',
  } = publicData || {};
  if (!isRecurring || isRecurring === 'no') return 1;
  if (numberOfSessions && endOption === 'after-sessions') {
    return parseInt(numberOfSessions, 10);
  }
  if (endDate && firstSession && endOption === END_OPTION_SPECIFIC_DATE) {
    // Both bounds are stored as midnight in the listing's timezone, so they have
    // to be read back in it — in the runtime's zone a London midnight can land on
    // the day before, costing the term its last session.
    const start = moment(firstSession).tz(timezone);
    const end = moment(endDate).tz(timezone);

    // If end date is before start date, return 0 sessions
    if (end.isBefore(start, 'day')) {
      return 0;
    }

    if (recurringOption === 'every-day') {
      // Rounded because the clocks change mid-term: two midnights 90 days apart
      // are 89 days and 23 hours, which `diff` would truncate to 89.
      const days = end.clone().startOf('day').diff(start.clone().startOf('day'), 'days', true);
      return Math.round(days) + 1;
    }
    if (recurringOption === 'every-week') {
      // Count actual weekly occurrences rather than using Math.ceil division,
      // which overshoots by 1 when endDate falls on the same day-of-week as firstSession.
      let count = 0;
      const current = start.clone();
      while (current.isSameOrBefore(end, 'day')) {
        count++;
        current.add(7, 'days');
      }
      return count;
    }
    if (recurringOption === 'every-weekday') {
      const weekdays = [];
      const current = start.clone();
      while (current.isSameOrBefore(end, 'day')) {
        if (current.isoWeekday() < 6) {
          // Monday to Friday
          weekdays.push(current.clone());
        }
        current.add(1, 'day');
      }
      return weekdays.length;
    }
  }
  return 1; // Default to 1 session if no other conditions are met
};
